import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";
import {
  getShopList,
  activeDeactiveShopById,
  deleteOShopById,
  syncShopCount,
} from "../../services/shop.service";
import MaterialTable from "material-table";
import moment from "moment";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { toast } from "react-hot-toast";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CustomModel from "../../components/CustomModel";
import Switch from "react-switch";
function ShopList(props: any) {
  const [shopListArray, setShopListArray] = useState([]);
  const [openModel, setOpenModel] = React.useState(false);
  const [shopUsername, setShopUsername] = useState("");
  const [totalShop, setTotalShop] = useState(0);

  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      getList();
    } else {
      props.history.push("/login");
    }
    localStorage.setItem("shop_id", "");
    localStorage.setItem("username", "");
    localStorage.setItem("redirect", "");
  }, []);

  useEffect(() => {
    let count = 0;
    for (let i in shopListArray) {
      count += parseFloat(shopListArray[i]["number_of_shops"]);
    }
    setTotalShop(count + shopListArray.length);
  }, [shopListArray]);

  const getList = () => {
    getShopList()
      .then((res: any) => setShopListArray(res?.data))
      .catch((err) => console.log(err));
  };
  const syncShop = async () => {
    try {
      await syncShopCount()?.then((result) => {
        if (result?.status == 200) {
          toast.success(result.message);
          getList();
        }
      });
    } catch (err: any) {
      console.log(err);
      toast.error(err.message);
      toast.error("Something went wrong, Please check username & email.");
    }
  };
  const editShop = (username: string) => {
    const shopDetail = shopListArray.filter(
      (item: any) => item.username === username
    )[0];
    localStorage.setItem("username", shopDetail["username"]);
    props.history.push({
      pathname: `/shop/edit/${username}`,
      details: shopDetail,
    });
  };
  const shopList = (username: string) => {
    props.history.push({
      pathname: `/shoplist/${username}`,
    });
  };
  const deleteShop = (id: string) => {
    setShopUsername(id);
    setOpenModel(true);
  };
  const [password, setPassword] = useState("");
  const [conform, setConform] = useState("");

  const onDeleteShop = () => {
    if (password == "") {
      toast.success("Enter Password");
      return;
    }
    if (password != "tArun@#123..&&mEhul@#123..") {
      toast.success("Enter Valid Password");
      return;
    }
    deleteOShopById(shopUsername)
      .then((res: any) => {
        toast.success(res.message);
        getList();
      })
      .catch((err) => toast.error(err.message));
    setOpenModel(false);
  };

  const toggleCustomModel = () => {
    setOpenModel(!openModel);
  };
  const handleChange = (username: string, available: boolean) => {
    activeDeactiveShopById(username, !available)
      .then((res: any) => {
        toast.success(res.message);
        getList();
      })
      .catch((err) => toast.error(err.message));
  };
  return (
    <>
      <CustomModel
        isModelOpen={openModel}
        toggleModel={toggleCustomModel}
        dialogTitle={"Remove Shop?"}
        dialogContentText={"This will deactivate your shop."}
        dialogBody={
          <div className="row">
            <div className="col-md-12">
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Enter Shop Name"
                type="text"
                onChange={(e) => setConform(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-md-12">
              <TextField
                fullWidth
                name="password"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)}
                label="Enter Password"
              />
            </div>
          </div>
        }
        dialogActionButton={
          <>
            <Button onClick={toggleCustomModel} color="primary">
              Cancel
            </Button>
            <Button
              disabled={shopUsername != conform}
              onClick={onDeleteShop}
              color="secondary"
            >
              Confirm
            </Button>
          </>
        }
      />

      <MaterialTable
        style={{ padding: "20px" }}
        title={
          <div className="page-title d-flex justify-content-between">
            {/* <h1>Shop List</h1> */}
            <button
              className="btn btn-primary primary-out"
              type="submit"
              onClick={() => props.history.push("/shop/add")}
            >
              Add Shop
            </button>
            <button
              className="btn btn-success ml-2"
              type="submit"
              onClick={() => syncShop()}
            >
              Sync Sub Shop Count
            </button>
            <h1 className="ml-2">
              <b>Total Shop-: {totalShop}</b>
            </h1>
          </div>
        }
        localization={{
          body: {
            emptyDataSourceMessage: (
              <div>
                <CircularProgress />
                <br></br>
                <b>Please Wait</b>
              </div>
            ),
          },
        }}
        columns={[
          {
            title: "Shop Id",
            field: "id",
          },
          {
            title: "User Name",
            field: "username",
            render: (rowData) =>
              rowData.username && (
                <div
                  onClick={() => {
                    props.history.push(`/shoplist/${rowData.username}`);
                  }}
                >
                  {rowData.username}
                </div>
              ),
          },
          {
            title: "Email",
            field: "email",
          },
          {
            title: "Phone",
            field: "phone",
          },
          {
            title: "Active",
            field: "available",
            render: (rowData) => (
              // rowData.available ? (
              <Switch
                onChange={() =>
                  handleChange(rowData?.username, rowData.available)
                }
                checked={rowData.available}
              />
            ),
            //   <Badge pill variant="primary">
            //     {" "}
            //     Available{" "}
            //   </Badge>
            // ) : (
            //   <Badge pill variant="danger">
            //     {" "}
            //     Unavailable{" "}
            //   </Badge>
            // ),
          },
          {
            title: "Created Date",
            field: "created_date",
            render: (rowData) =>
              rowData.created_date && (
                <>{moment(rowData.created_date).format("DD-MM-YYYY")}</>
              ),
          },
          {
            title: "Action",
            field: "action",
            render: (rowData: any) => (
              <>
                <div className="d-flex">
                  <Tooltip title="Edit">
                    <IconButton
                      aria-label="edit"
                      onClick={() => editShop(rowData?.username)}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete">
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteShop(rowData?.username)}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>
                  {/* <Tooltip title="Add Staff">
                    <IconButton
                      aria-label="Add Staff"
                      onClick={() => addStaff(rowData?.id)}
                    >
                      <PersonAddIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Add Role">
                    <IconButton
                      aria-label="Add Role"
                      onClick={() => addRole(rowData?.id)}
                    >
                      <PersonAddIcon color="primary" />
                    </IconButton>
                  </Tooltip> */}
                </div>
              </>
            ),
          },
          {
            title: "Number of Shops",
            field: "number_of_shops",
            render: (rowData: any) => (
              <>
                <Tooltip title="Goto List Of Shop">
                  <IconButton
                    aria-label="add"
                    onClick={() => shopList(rowData?.username)}
                  >
                    <>{rowData?.number_of_shops}</>
                  </IconButton>
                </Tooltip>
              </>
            ),
          },
          {
            title: "Is Franchise",
            field: "is_franchise",
          },
        ]}
        data={
          shopListArray &&
          shopListArray.map((shopListObj: any, index) => {
            return {
              name: shopListObj?.billing?.name,
              number_of_shops: shopListObj?.number_of_shops,
              username: shopListObj.username,
              email: shopListObj.email,
              phone: shopListObj.phone || "-",
              created_date: shopListObj.created_date,
              updated_date: shopListObj.updated_date,
              available: shopListObj.is_active,
              id: shopListObj.id,
              is_franchise: shopListObj.is_franchise,
            };
          })
        }
        options={{
          paging: true,
          pageSize: 10,
          pageSizeOptions: [50, 100, 200],
          sorting: true,
          actionsColumnIndex: -1,
          loadingType: "linear",
        }}
      />
    </>
  );
}

export default ShopList;
